import {Tab} from 'presentation/components/HeaderTabNavigation/types';
import {MyAppointmentsEnum, MyAppointmentsTitleEnum} from 'presentation/constants';
import IconNamesType from 'presentation/icons/IconNamesType';

const myAppointmentsTabs: Tab[] = [
	{
		route: MyAppointmentsEnum.MY_APPOINTMENTS,
		name: MyAppointmentsTitleEnum.MY_APPOINTMENTS,
		icon: 'event-filled' as IconNamesType,
	},
	{
		route: MyAppointmentsEnum.MY_APPOINTMENTS_HISTORY,
		name: MyAppointmentsTitleEnum.MY_APPOINTMENTS_HISTORY,
		icon: 'history-clock' as IconNamesType,
		id: 'myAppointmentsTutorial',
	},
];

export {myAppointmentsTabs};
